module.exports = __webpack_public_path__ + "static/media/intro_wheel_slack.1dae7ae6.png";